import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Kalkulator } from "@/pages/team/Kalkulator";

/**
 * Eine neue Kalkulation (Angebotsrechner, 21.09.2026). `?interessent=` oder
 * `?kunde=` belegen Titel und Drehadresse vor — die Einstiege sind die
 * Anfrage-Akte und die Kalkulationsliste unter „Anfragen".
 */
const suchSchema = z.object({
	interessent: z.string().optional(),
	kunde: z.string().optional(),
});

export const Route = createFileRoute("/_angemeldet/_mitarbeiter/kalkulator")({
	validateSearch: suchSchema,
	component: KalkulatorSeite,
});

function KalkulatorSeite() {
	const { interessent, kunde } = Route.useSearch();
	return <Kalkulator kalkulationId={null} interessentId={interessent} kundeId={kunde} />;
}
